export default __webpack_public_path__ + "static/media/facebook_icon_white.f4d557f8.svg";